import { request } from "../http/http";

export function getProceedingExhibitors(params) {
  return request({
    url: "/proceeding-exhibitor/page",
    method: "get",
    params
  });
}

export function getCurrentProceedingInfo() {
  return request({
    url: "/proceeding/getOne",
    method: "get"
  });
}



// WEBPACK FOOTER //
// ./src/services/proceedingExhibitor.js